import React, { useEffect, useState, useContext } from "react";
import styled, { keyframes, css } from "styled-components";

//assets

import loaderCircle from "assets/svg/loader-circle.svg";
import loaderB from "assets/svg/loader-b.svg";

//styles
import colors from "styles/colors.js";
import mediaQuery from "styles/mediaQuery.js";

//context
import { AppContext } from "layouts/Context.js";

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const slideIn = keyframes`
  from {
    transform: translateY(110%);
  }
  to {
    transform: translateY(0);
  }
`;

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100dvh;
  z-index: 99999;
  background-color: ${colors.darkOlive100};
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  pointer-events: ${({ $isVisible }) => ($isVisible ? "all" : "none")};
  transition: opacity 0.5s ease-in-out;
  
  ${({ $isHiding }) =>
    $isHiding &&
    css`
    height: 0;
    transition: height 1s 0.3s cubic-bezier(0.65, 0, 0.35, 1);
  `}
`;

const InnerWrapper = styled.div`
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100dvh;
z-index: 1000;
display: flex;
align-items: center;
justify-content: center;

`;

const LogoWrapper = styled.div`
display: flex;
justify-content: center;
align-items: center;
position: relative;  
${({ $isHiding }) =>
  $isHiding &&
  css`
    opacity: 0;
    transform: translateY(-10rem);
transition: opacity 0.8s 0.3s  ease-in-out, transform 0.8s 0.3s ease-in-out;
  `}
`;

const ServicesCircle = styled.img`
  width: 8.75rem;
  object-fit: contain;
  animation: ${rotate} 4s linear infinite;

  @media (max-width: ${mediaQuery.laptop}) {

  }
`;

const ServicesBWrapper = styled.div`
position: absolute;
top: 50%;
left: 50%;
overflow: hidden;
transform: translate(-40%, -50%);

`;

const ServicesB = styled.img`
  height: 3.5rem;
  object-fit: contain;
  transform: translateY(110%);
  animation: ${slideIn} 0.4s ease-out 0.5s forwards;
`;

const Loader = () => {
  const { data, set } = useContext(AppContext);
  const [isVisible, setIsVisible] = useState(data.firstLoad);
  const [isHiding, setIsHiding] = useState(false);

  useEffect(() => {
    if (!data.firstLoad) return;

    // Hide loader after page loads
    const timer = setTimeout(() => {
      setIsHiding(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 1500);
      setTimeout(() => {
        set({ firstLoad: false });
      }, 3000);
    }, 1100);

    return () => clearTimeout(timer);
  }, [data.firstLoad, set]);

  // Disable page scroll when loader is visible
  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isVisible]);

  if (!isVisible && !isHiding) return null;

  return (
    <Wrapper $isVisible={isVisible} $isHiding={isHiding}>
      <InnerWrapper>
        <LogoWrapper $isHiding={isHiding}>
          <ServicesCircle src={loaderCircle} alt="Bespoke Estates — Logo" />
          <ServicesBWrapper>
            <ServicesB src={loaderB} alt="Bespoke Estates — Logo" />
          </ServicesBWrapper>
        </LogoWrapper>
      </InnerWrapper>
    </Wrapper>
  );
};

export default Loader;
